import { t } from "i18next";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import img1 from '../assets/about1.jpg';
import img2 from '../assets/about2.jpg';
import img3 from '../assets/about3.jpg';
import img4 from '../assets/about4a.jpg';

const imgs = [ img1, img2, img3, img4 ];

export default function About(){

    // const navigate = 
    const getColClass = (i) => {
        if (i===1) {
            return "order-sm-2 pt-5 pb-3 py-sm-5";
        } else if (i==3) {
            return "order-sm-2 pt-3 pb-3 py-sm-5";
        } else {
            return "pt-5 pb-3 py-sm-5";
        }
    }

    return (
        <Container fluid as='main' className="about">
            <script type="text/javascript">
                console.log('hello');
            </script>
            <Row>
                <Col className="text-sm-center px-4">
                    <h1>{t('about.title')}</h1>
                </Col>
            </Row>
            {[...Array(4)].map((x, i) =>
                <Row key={i} className={i===1?"light-blue-bg py-3":"py-3"}>
                    <Col>
                        <Container><Row className="align-items-center">
                            <Col xs={12} sm={6} className={getColClass(i)}>
                                <img src={imgs[i]} alt={t(`about.sections.${i}.title`)} className="border border-2" />
                            </Col>
                            <Col xs={12} sm={6} className="px-sm-5 py-sm-5 pb-4">
                                <h3>{t(`about.sections.${i}.title`)}</h3>
                                <p dangerouslySetInnerHTML={{__html:t(`about.sections.${i}.body`)}} />
                                {i===2 && <Link to="/recipients" className="button">{t(`about.sections.${i}.cta`)}</Link>}
                                {/* {i===3 && <Link to="/apply" className="button">{t(`about.sections.${i}.cta`)}</Link>} */}
                            </Col>
                        </Row></Container>
                    </Col>
                </Row>
            )}
        </Container>
    );
}